import React, { useState } from 'react';
import {
  Alert, Button, Form, Modal,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import validator from 'validator';

import { changeRespondentEmail } from '../../../../bridge';
import { logError } from '../../../../helpers/logger';
import { __ } from '../../../../helpers/translations';

function ChangeEmailModal({
  respondentId, email, onChanged, onCancel,
}) {
  const [text, setText] = useState(email);
  const [invalidEmail, setInvalidEmail] = useState(null);

  const onClickSave = async () => {
    const cleanedText = text.trim();
    if (!validator.isEmail(cleanedText) || validator.isEmpty(cleanedText)) {
      setInvalidEmail('Invalid email');
      return;
    }

    const { error } = await changeRespondentEmail(respondentId, cleanedText);
    if (error) {
      logError('change_email_modal_on_click_save', error);
      setInvalidEmail(error);
    } else {
      setInvalidEmail(null);
      onChanged();
    }
  };

  return (
    <Modal show centered onHide={onCancel}>
      <Modal.Header>
        <Modal.Title>Change Participant Email</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3" controlId="valid-email">
          <Form.Control
            type="email"
            autoFocus
            value={text}
            onChange={(e) => setText(e.target.value)}
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onClickSave();
              }
            }}
          />
        </Form.Group>
        {invalidEmail && (
          <Alert variant="danger">{invalidEmail}</Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel}>
          {__('G106')}
        </Button>
        <Button variant="primary" onClick={onClickSave}>
          {__('G74')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ChangeEmailModal.propTypes = {
  email: PropTypes.string,
  onCancel: PropTypes.func,
  onChanged: PropTypes.func,
  respondentId: PropTypes.string,
};

export default ChangeEmailModal;
